import { ExclamationCircleOutlined } from '@ant-design/icons'
import { POSITION_MAP } from '@components/LocalMerchant/SiDa/constant'
import { ctrlTextLen, getMoney } from '@hlj/hlj-utils'
import { isSiDaProperty } from '@merchant-backend/util'
import Img from '@UI/Img'
import cls from 'classnames'
import { Flex, Tooltip } from 'hljd'
import React from 'react'
import style from './style.module.less'

export default ({
  item,
  moneyPosition = 'center',
  showNumbers = true,
  showPrice = true,
  showEmceeSchedulesCount = true,
  nameColor = '#333',
  desColor = '#666',
  priceColor = '#448afc',
  showBusy = true,
  showDes = true,
  showWarning = false,
  ...rest
}) => {
  let {
    logoPath,
    logo_path,
    name,
    des,
    isBusy,
    is_busy,
    position,
    workingSeniority,
    working_seniority,
    merchantComment,
    merchant_comment,
    emceeSchedulesCount,
    emcee_schedules_count,
    minPrice,
    min_price,
    activeWorksPcount
  } =
    item || {}

  merchantComment = merchantComment || merchant_comment
  logoPath = logoPath || logo_path
  isBusy = isBusy || is_busy
  workingSeniority = workingSeniority || working_seniority
  emceeSchedulesCount = emceeSchedulesCount || emcee_schedules_count
  minPrice = minPrice || min_price
  const { score, totalGoodCount } = merchantComment || {}

  return (
    <Flex sp {...rest}>
      <Flex>
        <Img
          style={{
            width: 62,
            height: 62,
            flexShrink: 0,
            borderRadius: '50%',
            marginRight: 15
          }}
          src={logoPath}
        />
        <Flex d="v" sp>
          <Flex wrap style={{ alignItems: 'center' }}>
            <span
              style={{
                fontWeight: 'bold',
                marginRight: 5,
                color: nameColor
              }}
            >
              {name}
            </span>
            {showWarning &&
              !activeWorksPcount && (
                <Tooltip
                  title={'该成员未上传套餐，将影响店铺在用户APP端的展示!'}
                >
                  <ExclamationCircleOutlined
                    style={{
                      fontSize: 12,
                      marginRight: 5,
                      color: '#fea833'
                    }}
                  />
                </Tooltip>
              )}
            {workingSeniority > 0 && (
              <span className={cls(style.tag, style.position)}>
                从业{workingSeniority}年{position && (
                  <span>·{POSITION_MAP[position]}</span>
                )}
              </span>
            )}
            {!isSiDaProperty() &&
              showBusy &&
              isBusy == 1 && (
                <span className={cls(style.tag, style.busy)}>档期紧俏</span>
              )}
          </Flex>

          {showDes &&
            des && (
              <Tooltip title={des}>
                <div style={{ margin: '5px 0', color: desColor }}>
                  {ctrlTextLen(des, 19)}
                </div>
              </Tooltip>
            )}

          {showNumbers && (
            <Flex className={style.numbers} sp vc>
              <Flex>
                <span className={style.score}>
                  <span className={style.num} style={{ color: nameColor }}>
                    {score || 0}
                  </span>
                  <span style={{ color: desColor }}>评分</span>
                </span>

                <span className={style.goodCount}>
                  <span className={style.num} style={{ color: nameColor }}>
                    {totalGoodCount > 999 ? '999+' : totalGoodCount || 0}
                  </span>
                  <span style={{ color: desColor }}>好评数</span>
                </span>

                {showEmceeSchedulesCount && (
                  <span className={style.count}>
                    <span className={style.num} style={{ color: nameColor }}>
                      {emceeSchedulesCount || 0}
                    </span>
                    <span style={{ color: desColor }}>档期数</span>
                  </span>
                )}
              </Flex>

              {showPrice &&
                moneyPosition === 'bottom' && (
                  <Flex
                    className={cls(style.price)}
                    style={{ color: priceColor }}
                  >
                    {getMoney(minPrice)}
                  </Flex>
                )}
            </Flex>
          )}
        </Flex>
      </Flex>

      {showPrice &&
        moneyPosition === 'center' && (
          <Flex vc className={cls(style.price)} style={{ color: priceColor }}>
            {getMoney(minPrice)}
          </Flex>
        )}
    </Flex>
  )
}
